// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"3938fd59","513":"07aebe80","703":"b1bd5581","787":"cc5fc6cc","885":"bbd12f14"}[chunkId] + ".chunk.js";
};